import { forwardRef } from 'react';
import type {
  ButtonHTMLAttributes,
  HTMLAttributes,
  InputHTMLAttributes,
  SelectHTMLAttributes,
} from 'react';

const cx = (...values: Array<string | undefined | false | null>) =>
  values.filter(Boolean).join(' ');

export const NeoCard = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div ref={ref} className={cx('card', className)} {...rest} />
  ),
);
NeoCard.displayName = 'NeoCard';

export const NeoRow = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div ref={ref} className={cx('row', className)} {...rest} />
  ),
);
NeoRow.displayName = 'NeoRow';

export const NeoTable = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div ref={ref} className={cx('table', className)} {...rest} />
  ),
);
NeoTable.displayName = 'NeoTable';

export const NeoTableFooter = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => (
    <div ref={ref} className={cx('table-footer', className)} {...rest} />
  ),
);
NeoTableFooter.displayName = 'NeoTableFooter';

export const NeoInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...rest }, ref) => (
    <input ref={ref} className={cx('input', className)} {...rest} />
  ),
);
NeoInput.displayName = 'NeoInput';

export const NeoSelect = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...rest }, ref) => (
    <select ref={ref} className={cx('select', className)} {...rest} />
  ),
);
NeoSelect.displayName = 'NeoSelect';

export const NeoBtnPrimary = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, ...rest }, ref) => (
    <button ref={ref} className={cx('btn', 'primary', className)} {...rest} />
  ),
);
NeoBtnPrimary.displayName = 'NeoBtnPrimary';

export const NeoBtnGhost = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, ...rest }, ref) => (
    <button ref={ref} className={cx('btn', 'ghost', className)} {...rest} />
  ),
);
NeoBtnGhost.displayName = 'NeoBtnGhost';

export const NeoBtnTertiary = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, ...rest }, ref) => (
    <button ref={ref} className={cx('btn', 'tertiary', className)} {...rest} />
  ),
);
NeoBtnTertiary.displayName = 'NeoBtnTertiary';
